import React from 'react';
import { useTheme } from '../../contexts/ThemeContext';

interface GymSubHeaderProps {
  icon: React.ReactNode;
  title: string;
  subtitle?: string;
  accentFrom?: string;
  accentTo?: string;
  actions?: React.ReactNode;
}

const GymSubHeader: React.FC<GymSubHeaderProps> = ({
  icon, title, subtitle, accentFrom = 'from-amber-400', accentTo = 'to-orange-400', actions
}) => {
  const { darkMode } = useTheme();

  return (
    <div className={`rounded-lg border-l-4 px-4 py-2.5 mb-4 flex items-center justify-between ${
      darkMode ? 'bg-gray-800/50 border-amber-600/50' : 'bg-gray-50 border-amber-500/50'
    }`}>
      <div className="flex items-center gap-2.5">
        <span className={darkMode ? 'text-amber-300' : 'text-amber-700'}>{icon}</span>
        <div>
          <h2 className={`text-sm font-bold bg-clip-text text-transparent bg-gradient-to-r ${accentFrom} ${accentTo}`}>
            {title}
          </h2>
          {subtitle && (
            <p className={`text-[10px] ${darkMode ? 'text-gray-500' : 'text-gray-400'}`}>{subtitle}</p>
          )}
        </div>
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </div>
  );
};

export default GymSubHeader;
